import React, { useState, useRef, useEffect, useCallback } from "react";
import { ReactComponent as ArrowRight } from "../../../../assets/icons/arrowright.svg";
import { ReactComponent as ArrowLeft } from "../../../../assets/icons/arrowleft.svg";
import { ReactComponent as Spinner } from "../../../../assets/icons/spinner.svg";
import { ReactComponent as MapPad } from "../../../../assets/images/signUp/man-with-pad.svg";
import Logo from "../../Logo";
import { Button, SideSVG } from "../../../common";
import { useSelector, useDispatch } from "react-redux";
import { SearchResults } from "./SearchResults";
import { setCountryData, setSearch } from "../../../../store/search/searchSlice";
import {
  setSearchResults,
  setSearchCount,
} from "../../../../store/search/searchSlice";
import {
  useCreateCompanyMutation,
  useIndividualCompanyMutation,
} from "../../../../store/Company/companyApiSlice";
import { setCompanyData } from "../../../../store/Company/companySlice";
import { setCompany } from "../../../../store/search/searchSlice";
import CompanyNotFound from "./CompanyNotFound";
import { Countries } from "../../Home/CountryFlag";
import { ReactComponent as Magnifier } from "../../../../assets/icons/Magnifier.svg";
import { ReactComponent as GPS } from "../../../../assets/icons/GPS.svg";
import { ReactComponent as Warning } from "../../../../assets/icons/Warning.svg";
import useSearchCompany from "../../../../Hooks/useSearchCompany";
import { setFilledCompany } from "../../../../store/claim/claimSlice";
import useCountryCode from "../../../../Hooks/useCountryCode";

const SearchCompany = ({ onNext, onPrev }) => {
  const {
    searchQuery,
    countryData,
    searchResults,
    worldBoxToken,
    companySelectedByUser,
    searchCount,
  } = useSelector((state) => state.search);
  const { countryCode } = useCountryCode();
  const [companyNotFound, setFoundNotFound] = useState(false);
  const dispatch = useDispatch();
  const searchInputRef = useRef();
  const [errors, setErrors] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [displayUl, setDisplayUl] = useState(false);
  const [searchTerm, setSearchTerm] = useState(searchQuery ?? "");
  const [country, setCountry] = useState(countryData ?? {
    name: "Select Country",
    flag: null,
    code: null,
  });
  const dropdownRef = useRef(null);

  const handleCountrySelect = (countryCode) => {
    const countryData = Countries.find(country => country.code === countryCode);
    const countryDetail = {
      name: countryData.name,
      flag: countryData.file_url,
      code: countryData.code,
    };
    dispatch(setCountryData(countryDetail));
    setCountry(countryDetail)
  }

  // useEffect(() => {
  //   if (countryCode && country.code !== countryCode) {
  //     handleCountrySelect(countryCode)
  //   }
  // }, [])

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.value = searchQuery ?? ""
    }
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDisplayUl(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleCountry = (e, flag, option) => {
    const countryDetail = {
      name: option.name,
      flag: option.file_url,
      code: option.code,
    };
    setCountry(countryDetail);
    setDisplayUl(!displayUl);
  };

  const handleDisplayUl = (e) => {
    e.preventDefault();
    setDisplayUl(!displayUl);
  };

  //search filter
  const handleFilteredData = (event) => {
    const searchLetters = event.target.value;
    setSearchTerm(searchLetters);

    const filteredData = Countries.filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filteredData);
  };

  //handle location popup
  const handleLocationPopup = async (e) => {
    e.preventDefault();
    try {
      handleCountrySelect(countryCode);
    } catch (error) {
    }
    setDisplayUl(false);
  };

  const { token, userInfo } = useSelector((state) => state.auth);

  const { data, isLoading, message } = useSearchCompany(
    searchQuery,
    country?.code ?? countryData?.code,
    token,
    worldBoxToken,
    true
  );


  //company register
  const [createCompany, { isLoading: companyCreating }] =
    useCreateCompanyMutation();

  const [individualCompany] = useIndividualCompanyMutation();

  useEffect(() => {
    if (data) {
      dispatch(setSearchResults(data));
      dispatch(setSearchCount(data.length));
    }
  }, [data, dispatch]);

  function searchCompany(fn, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        fn.apply(context, args);
      }, wait);
    };
  }

  const searchOnChange = useCallback(searchCompany(dispatch, 400), []);

  const handleSearch = (e) => {
    e.preventDefault();

    if (country.code === null) {
      setDisplayUl(true);
      return;
    }

    if (searchInputRef.current.value.length < 3) {
      dispatch(setSearchResults([]));
      dispatch(setSearchCount(0));
      dispatch(setCompany(null));
      return;
    }
    errors.empty = "";
    setErrors(errors);
    if (searchInputRef.current.value.length > 2) {
      searchOnChange(setSearch(searchInputRef.current.value));
    }
  };

  const handleCompanySave = async () => {
    const errors = {};

    if (country.code === null) {
      errors.country = "Please select country.";
      setErrors(errors);
      return;
    }

    if (searchInputRef.current.value.trim() === "") {
      errors.empty = "Please enter business name.";
      setErrors(errors);
      return;
    }

    if (!companySelectedByUser?.name && !companySelectedByUser?.companyID) {
      errors.notSelected = "Please Select a business";
      setErrors(errors);
      return;
    }

    if (companySelectedByUser?.companyID) {
      try {
        const individualCompanyData = await individualCompany({
          data: {
            individualID: userInfo?.individual[0]?.individualID,
            companyID: companySelectedByUser?.companyID,
          },
          token,
        });
        if (individualCompanyData) {
          dispatch(setCompanyData(companySelectedByUser));
          onNext();
        }
      } catch (error) {
        errors.backend =
          error?.data || "Internal Server Error. Please try again later.";
        setErrors(errors);
      }
    } else {
      try {
        const jsonData = {
          registered_company_name: companySelectedByUser.name,
          wb_win: companySelectedByUser?.win,
          country_code: country?.code,
          new_company: 0,
          companyID: companySelectedByUser?.companyID,
        };
        dispatch(setFilledCompany(jsonData))
        onNext();
      } catch (error) {
        errors.backend =
          error?.data || "Internal Server Error. Please try again later.";
        setErrors(errors);
      }
    }
  };

  const handleSwitch = () => {
    setCompany(null);
    setFoundNotFound((prevState) => !prevState);
  };

  return (
    <>
      {companyNotFound ? (
        <CompanyNotFound handleSwitch={handleSwitch} onNext={onNext} />
      ) : (
        <section className="relative py-20 lg:py-0 overflow-hidden">
          <div className="px-0 mx-auto">
            <div className="mx-auto relative">
              <Logo />
              <div className="flex px-4 -mx-4 xl:items-center items-center max-h-screen">
                <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
                  <div className="max-w-md lg:py-20 mx-auto ">
                    <h3 className="font-heading text-f24 sm:text-f36 text-primary font-bold mb-4 text-center">
                      Search your Business
                    </h3>

                    <form>
                      <label
                        for="search-dropdown"
                        className="block mb-1 text-sm text-secondarytwo font-semibold text-left"
                      >
                        Select Country
                      </label>

                      <div className="flex my-2 mb-6" ref={dropdownRef}>
                        <div
                          className="w-full justify-between cursor-pointer truncate flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 focus:ring-gray-300 "
                          onClick={handleDisplayUl}
                        >
                          <div
                            className="cursor-pointer flex text-left text-xs overflow-hidden"
                            role="presentation"
                          >
                            {country?.flag && (
                              <img
                                src={country.flag}
                                width="20px"
                                height="20px"
                                className="mr-2 h-5"
                                alt="hello"
                              />
                            )}
                            {country?.name}
                          </div>
                          <ArrowLeft
                            className={displayUl ? "rotate-90" : "-rotate-90"}
                          />
                        </div>
                        <div
                          className={`${displayUl ? "" : "hidden"
                            } shadow-boxPopup rounded-md mt-12 w-96 bg-white p-5 sm:max-h-84 sm:min-h-fit absolute z-10`}
                        >
                          <div
                            className="text-link border-b border-slate p-3 mb-3 font-semibold cursor-pointer items-center flex"
                            onClick={handleLocationPopup}
                          >
                            <GPS className="mr-3" /> Detect using GPS
                          </div>
                          <div className="flex items-center">
                            <Magnifier className="absolute mb-3 mx-3" />

                            <input
                              type="text"
                              className="border-input border w-full p-2 px-11 mb-3 shadow-search rounded"
                              onKeyUp={handleFilteredData}
                            />
                          </div>
                          <ul className="overflow-y-auto shadow-boxPopup border-greyFade border sm:max-h-64 sm:min-h-fit rounded-md">
                            {filteredData.map((option) => (
                              <li
                                onClick={(e) =>
                                  handleCountry(
                                    e.target.innerText,
                                    option.file_url,
                                    option
                                  )
                                }
                                className="px-4 py-3 cursor-pointer hover:bg-input flex text-left text-xs"
                                role="presentation"
                              >
                                <img
                                  src={option.file_url}
                                  width="20px"
                                  height="20px"
                                  className="mr-2 h-5"
                                  alt="hello"
                                />
                                {option.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <label
                        for="search-dropdown"
                        className="block mb-1 text-sm text-secondarytwo font-semibold text-left"
                      >
                        Enter business name
                      </label>
                      <div className="flex mt-2 mb-2">
                        <div className="relative w-full">
                          <input
                            type="search"
                            id="search-dropdown"
                            className="block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 "
                            placeholder="Search"
                            required
                            onChange={handleSearch}
                            ref={searchInputRef}
                          />
                          {message !== "" && <div className="bg-warning border-warning border rounded-lg p-1 my-2 text-left text-warning flex gap-3 items-center text-f10">
                            <Warning />
                            <span>
                              {message === 'error' ? <span>Technical issues may affect results. Please try again later.</span> : " " + message}
                            </span>
                          </div>}
                          {isLoading && (
                            <div className="absolute right-2 top-3 bg-white">
                              <Spinner />
                            </div>
                          )}
                        </div>
                      </div>
                    </form>

                    {errors?.backend && (
                      <p className="text-red-500 text-sm text-left py-2">
                        {errors?.backend}
                      </p>
                    )}
                    {errors?.country && (
                      <p className="text-red-500 text-sm text-left py-2">
                        {errors.country}
                      </p>
                    )}
                    {errors?.empty && (
                      <p className="text-red-500 text-sm text-left py-2">
                        {errors.empty}
                      </p>
                    )}
                    {searchCount > 150 && (
                      <p className="text-red-500 text-sm text-left py-2">
                        {`You have reached the maximum number of search results. Please refine your search.`}
                      </p>
                    )}
                    {searchResults?.length > 0 && (
                      <SearchResults currentResults={searchResults} />
                    )}
                    {errors.notSelected && (
                      <p className="text-red-500 text-sm text-left py-2">
                        {errors.notSelected}
                      </p>
                    )}
                    <div className="text-left text-secondary mb-8 flex gap-1">
                      Cannot find the business?{" "}
                      <Button
                        onClick={handleSwitch}
                        classes=" font-semibold text-primaryText "
                      >
                        Click here
                      </Button>
                    </div>
                    <div className="flex justify-between gap-2">
                      <button
                        className="inline-flex items-center justify-start mr-2 gap-4 text-primaryText font-bold w-full"

                      >
                        <ArrowLeft onClick={onPrev} />
                        <span className="relative" onClick={onPrev}>Go Back</span>
                      </button>
                      <button
                        className={`relative group w-full py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center gap-4 `}
                        type="submit"
                        onClick={handleCompanySave}
                      >
                        <span className="relative">
                          {companyCreating ? <Spinner /> : "Save & Continue"}
                        </span>
                        <ArrowRight />
                      </button>
                    </div>
                  </div>
                </div>

                <SideSVG SVG={MapPad} positions="bottom-0  left-[-25%]" />
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default SearchCompany;
